import { DeltaDate } from 'src/app/core/infrastructure/delta-date';

export class ProblemModel {
  id: number;
  publishDate: Date;
  fixDate: Date;
  title: string;
  description: string;
  isActive: boolean;
  image: any;
  type: string;
}

export function getTimeLeft(problem: ProblemModel): string {
  return DeltaDate.getTimeLeft(new Date(), new Date(problem.fixDate));
}
